import { render, staticRenderFns } from "./information.vue?vue&type=template&id=0d2e0b78&scoped=true"
import script from "./information.vue?vue&type=script&setup=true&lang=js"
export * from "./information.vue?vue&type=script&setup=true&lang=js"
import style0 from "./information.vue?vue&type=style&index=0&id=0d2e0b78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2e0b78",
  null
  
)

export default component.exports